import React from 'react';
import styles from './styles.css';
import { useTranslation } from 'react-i18next';

export default function SignificantChangesPanel({ dropdowns }) {
	const { t } = useTranslation();
	return (
		<div className="idp-footer__middle advanced-settings">
			<div className="uk-width-1-2@s">
				{dropdowns.map((dropdown) => (
					<label>
						{dropdown.text}
						<br />
						{t('Confidence Level')}
						<select className={styles.dropdown} onChange={(e) => dropdown.onChange(e.target.value)}>
							{dropdown.options.map((option) => (
								<option value={option}>{`${option}%`}</option>
							))}
						</select>
					</label>
				))}
			</div>
		</div>
	);
}
